import { render } from "./index.vue?vue&type=template&id=15072ae5&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=15072ae5&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-15072ae5"

export default script